import router from '../router'

router.beforeEach(async (to, from, next) => {
  const auths = to.meta.auth || []
  if(!auths || auths.length < 1) {
    return next()
  }
  for (let i = 0; i < auths.length; i++) {
    const func = auths[i]
    const flag  = await func(to, from, next)
    if (!flag) return
  }
})

router.afterEach((to)=>{
  if (to.meta.title) window.document.title = to.meta.title;
})